<template>
  <li class="productgrid--item imagestyle--natural">
    <div class="productitem">
      <a class="productitem--image-link" :href="url" tabindex="-1">
        <figure class="productitem--image" :class="gridImageClass">
          <img
            :src="sizedImageSrc"
            :alt="title"
            :srcset="`${sizedImageSrc} 1x`"
            class="productitem--image-primary"
          />
          <span
            v-show="displaySoldOut"
            class="productitem--badge badge--soldout"
          >
            {{ soldOutLabel }}
          </span>
        </figure>
      </a>
      <div class="productitem--info">
        <h2 class="productitem--title">
          <a :href="url">
            {{ title }}
          </a>
        </h2>

        <div class="productitem--price">
          <div class="price--main">
            <span class="money" v-html="price" />
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import * as ShopifyImage from '@shopify/theme-images';

export default {
  name: 'DynamicCollectionTabsGridItem',
  props: {
    id: {
      type: String
    },
    imageSrc: {
      type: String
    },
    price: {
      type: String
    },
    tags: {
      type: Array
    },
    title: {
      type: String
    },
    url: {
      type: String
    },
    available: {
      type: Boolean
    },
    soldOutLabel: {
      type: Boolean
    }
  },
  computed: {
    sizedImageSrc() {
      return ShopifyImage.getSizedImageUrl(this.imageSrc, 'x290');
    },

    gridImageClass() {
      if (
        this.tags &&
        this.tags.length > 0 &&
        this.tags.some((tag) => tag.startsWith('grid-size:'))
      ) {
        return `u-image-size-${
          this.tags.find((tag) => tag.startsWith('grid-size')).split(':')[1]
        }`;
      }

      return '';
    },

    displaySoldOut() {
      return this.available ? false : true;
    }
  }
};
</script>
